import { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const defaultSettings = {
  whatsapp_number: '+1234567890',
  admin_email: '',
  notification_email: '',
  calendly_url: 'https://cal.com/velmont-society/consultation',
  seo_title: 'Velmont Society | Private Luxury Concierge',
  seo_description: 'Private luxury concierge creating bespoke VIP experiences in Brazil. International standards. Brazilian insider access. By invitation only.',
  seo_keywords: 'luxury concierge, Brazil, São Paulo, Rio de Janeiro, VIP experiences, private travel, exclusive access'
};

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(defaultSettings);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings`);
        setSettings({ ...defaultSettings, ...response.data });
      } catch (error) {
        console.log('Using default settings');
      } finally {
        setLoading(false);
      }
    };
    fetchSettings();
  }, []);

  const getWhatsAppUrl = (message = '') => {
    const number = settings.whatsapp_number?.replace(/[^0-9+]/g, '') || '+1234567890';
    const encodedMessage = encodeURIComponent(message);
    return `https://wa.me/${number}?text=${encodedMessage}`;
  };

  return (
    <SettingsContext.Provider value={{ settings, loading, getWhatsAppUrl }}>
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings must be used within a SettingsProvider');
  }
  return context;
};

export default SettingsContext;
